var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"blue-grey lighten-5"},[(_vm.role == 'client')?_c('NavBarClient'):_vm._e(),(_vm.role == 'contractor')?_c('NavBarContractor'):_vm._e(),(_vm.role != 'client' && _vm.role != 'contractor')?_c('NavBar'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }